module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABJklEQVRYR+3V30ZFQRTH8VnzOPUSPUWii+hi/aaIQ0SKuigiImL/ORfRRXR6yJXhdLMN82etcUT7dm++H7OXWeR2/NCO++5vAOZ5PheRAwCH1ieWPYFpmm6ccw/b8Lc1IgsYx3HPe78Rkf0eiCwgRiOCiDbOOXNEEaAnohjQC1EF6IGoBlgjmgCWiGaAFUIFsECoAVqECUCD6An4AnCUW14mgMRV/QngOBeP79WA5bIiog9mPimJqwGJTfkO4LQ0rgIsj52I1szMNfFmQCI+MvNZbbwJkBi4NwAXLfFqwDIuIq8hhFVrvAqQmPYXZr7UxIsBiWl/BnCljRcBEv/8CcC1RbwIMAzDvff+bht8BHBrFS8CxI8igogohPALMTOor2Kt5B/wA2/glSE4BIdGAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/right-min.png
// module id = /IG7
// module chunks = 1